module.exports = __webpack_public_path__ + "static/media/user.38d31b12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user.jpg
// module id = 256
// module chunks = 0